<template>
  <div class="lobby-card-wrapper">
    <div class="content">
      <img v-if="logoUrl" class="logo" :src="logoUrl" :alt="t('logo')" />
      <FriedH2>{{ t('dsr_unavailable_header') }}</FriedH2>
      <FriedParagraph>{{ t('dsr_unavailable_paragraph') }}</FriedParagraph>
      <div class="sub-content">
        <FriedH3>{{ t('dsr_now_what') }}</FriedH3>
        <FriedParagraph>{{ t('dsr_now_what_paragraph') }}</FriedParagraph>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'DsrUnavailable',
  props: {
    logoUrl: {
      type: String,
      default: null,
    },
  },
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '../scss/lobby-card-wrapper';

.sub-content {
  margin-top: var(--spacing-200);
}
</style>
